import template from './employee_view_leave_component.html';
import * as Utils from '../../lib/savanna_utils.js';
import tr from '../../lib/default-translator.js';

class Leave
{
	constructor(config)
	{
		let data = Object.assign({
			leave_taken_id: null,
			leave_linked_id: ko.observable('').extend({ update_amount: { parent: this, type: 'leave_linked_id' } }),
			employee_id: Utils.get_local_storage_nullable('employee_id'),
			date_start: ko.observable('').extend({ update_amount: { parent: this, type: 'date_start' } }),
			date_end: ko.observable('').extend({ update_amount: { parent: this, type: 'date_end' } }),
			is_amount_editiable: ko.observable(false),
			amount: ko.observable(0),
			amount_info: ko.observable(''),
			leave_type_id: ko.observable('').extend({ update_amount: { parent: this, type: 'leave_type_id' } }),
			description: '',
			reason: '',
			taken_rate: null,
			is_overlapping: false,
			is_history: false,
			converted_from_leave_linked_id: '',
			approved: true,
			icon: '',
			color: '',
			has_attachment: false,
			transaction_id: null
		}, config);

		ko.mapping.fromJS(data, {}, this)
	}
}

class LeaveAdjustment
{
	constructor(config)
	{
		let data = Object.assign({
			leave_adjustment_id: null,
			leave_linked_id: null,
			employee_id: Utils.get_local_storage_nullable('employee_id'),
			entry_date: null,
			amount: ko.observable(0),
			reason: '',
			is_history: false,
			converted_from_leave_linked_id: '',
			approved: true,
			description: '',
			icon: ''
		}, config);

		ko.mapping.fromJS(data, {}, this)
	}
}

class EmployeeViewLeaveComponentViewModel
{
	constructor(bindings)
	{
		this.bindings = bindings;
		this.employee = ko.observable();
		this.employee_id = ko.observable();

		this.leave_taken = ko.observableArray();
		this.leave_taken_consolidated = ko.observableArray();
		this.leave_adjustments = ko.observableArray();
		this.leave_earned = ko.observableArray();
		this.leave_types = ko.observableArray();
		this.leave_summary = ko.observableArray();
		this.leavetaken_sortingMethod = ko.observable('6_months');
		this.leaveadjustment_sortingMethod = ko.observable('past_year');
		this.leave_earned_sortingMethod = ko.observable('6_months');

		this.current_page_number = ko.observable(1);
		this.current_page_size = ko.observable(20);
		this.page_count = ko.observable(1);
		this.pagination_summary = ko.observable('');
		this.number_of_records = ko.observableArray([20, 50, 100, 200]);
		this.selected_number_of_records = ko.observable(20);
		this.leave_summary_linked_leave = ko.observableArray();
		this.rate_types = ko.observableArray();
		this.summary_filter_earned_end = ko.observable(Utils.toJSONDateString(new Date()));
		this.logged_in_employee_id = Utils.get_local_storage_nullable('employee_id');
		this.loading = ko.observable(true);

		if (bindings.employee && ko.isObservable(bindings.employee))
			bindings.employee.subscribe((nv) => {
				if (nv)
				{
					this.employee(nv)
					this.employee_id(nv.employee_id)
					this.updateData()
				};
			});

		if (bindings.employee_id && ko.isObservable(bindings.employee_id))
			bindings.employee_id.subscribe((nv) => {
				this.employee_id(nv);
			});

		if (bindings.employeeEventDates)
			this.employeeEventDates = bindings.employeeEventDates;
		else
			this.employeeEventDates = ko.observable([]);

		this.selected_number_of_records.subscribe((newVal) => {
			this.current_page_size(newVal);
			this.updateData();
		});

		// update when filter leave dates change
		this.leavetaken_sortingMethod.subscribe((newText) => {
			this.updateData();
		});

		this.leaveadjustment_sortingMethod.subscribe((newText) => {
			this.updateData();
		});

		this.leave_earned_sortingMethod.subscribe((newText) => {
			this.updateData();
		});

		this.summary_filter_earned_end.subscribe((newText) => {
			if (this.summary_filter_earned_end() != '')
				this.updateData();
		});

		// update suggested dates
		// TODO : put in some sort of loader so it doesnt constantly call function ?
		ko.extenders.update_amount = (target, context) => {
			let employee_id = this.employee_id();

			target.subscribe(async () => {
				if (context.type == 'date_start' || context.type == 'date_end' || context.type == 'leave_type_id' || context.type == 'leave_linked_id')
				{
					if (context.parent.date_start() != '' && context.parent.date_end() != '')
					{
						// we are forcing people to make use of suggested day, but if they are entering for one date only
						// we are enabling the amount field so they can enter half a day etc.
						if (context.parent.date_start() == context.parent.date_end())
							context.parent.is_amount_editiable(false);
						else
							context.parent.is_amount_editiable(true);

						let res = await Grape.fetches.postJSON('/leave/calculate_work_days', { _date_start: context.parent.date_start(), _date_end: context.parent.date_end(), leave_linked_id: context.parent.leave_linked_id() });

						if (res.status == 'OK')
							context.parent.amount(res.amount_days);
						else if (res.status == 'ERROR')
						{
							Grape.alerts.apiError(res);
							context.parent.amount(0);
						}
						else
						{
							Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });
							context.parent.amount(0);
						}

						// check if date range selected doesn't already have leave assigned
						let res_range = await Grape.fetches.postJSON('/leave/is_leave_range_free', { date_start: context.parent.date_start(), date_end: context.parent.date_end(), employee_id: employee_id });

						if (res_range.is_free != undefined)
							context.parent.is_overlapping(!res_range.is_free);
						else
							context.parent.is_overlapping(false);

						// get extra info - is this date range next to adjacent jewish holiday ?
						let res_penalty = await Grape.fetches.postJSON('/leave/is_date_range_adjacent_penalty_holiday', { _date_start: context.parent.date_start(), _date_end: context.parent.date_end(), leave_linked_id: context.parent.leave_linked_id() });

						if (res_penalty.status == 'OK')
							context.parent.amount_info(res_penalty.result);
						else if (res_penalty.status == 'ERROR')
						{
							context.parent.amount_info('');
							Grape.alerts.apiError(res_penalty);
						}
						else
							context.parent.amount_info('');
					};
				};
			});
		};
	};

	show_employment_listing_help()
	{
		Grape.dialog.open('EmploymentListingHelp', { employee_id: this.logged_in_employee_id });
	}

	show_leave_summary_help()
	{
		Grape.dialog.open('LeaveSummaryHelp', { employee_id: this.logged_in_employee_id });
	}

	show_leave_taken_help()
	{
		Grape.dialog.open('LeaveTakenHelp', { employee_id: this.logged_in_employee_id });
	}

	show_leave_adjustments_help()
	{
		Grape.dialog.open('LeaveAdjustmentsHelp', { employee_id: this.logged_in_employee_id });
	}

	show_leave_earned_help()
	{
		Grape.dialog.open('LeaveEarnedHelp', { employee_id: this.logged_in_employee_id });
	}

	back_to_top()
	{
		document.body.scrollTop = 0; // For Safari
		document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
	}

	page_click(page_number)
	{
		this.current_page_number(page_number);
		this.updateData();
	}

	async updateData()
	{
		try
		{
			
			// Reset rate types
			this.rate_types([]);
	
			// Fetch rate types
			let options = {
				table: 'v_modified_leave_rate_type',
				schema: 'savanna',
				limit: 1000000,
				sortfield: 'rate',
				sortorder: 'asc',
			};
	
			let rate_types_res = await Grape.fetches.getJSON('/api/record', options);
	
			if (rate_types_res?.status === 'OK') {
				this.rate_types(rate_types_res.records.map((record) => record.rate));
			}
	
			// Fetch linked leave types
			let res_linked = await Grape.fetches.postJSON('/leave/get_linked_leave', { employee_id: this.employee_id() });
			if (res_linked?.status !== 'ERROR') {
				this.leave_types(res_linked);
			}
	
			// Fetch leave summary
			let data = await Grape.fetches.getJSON(`/leave/${this.employee_id()}/summary/2012-01-01/${this.summary_filter_earned_end()}`, {});
	
			if (data)
			{				
				clearColorToGlobal();
				data.leave?.forEach((leaveItem) => addColorToGlobal(leaveItem.leave_linked_id));
	
				this.leave_summary_linked_leave(data.leave || []);
				this.leave_summary.removeAll();
				this.leave_summary.push(ko.mapping.fromJS(data));
	
				// Fetch leave earned
				let leave_earned_res = await this.fetch_leave_earned();
	
				if (leave_earned_res)
					this.leave_earned_response(leave_earned_res);

				// Fetch leave taken consolidated
				let leave_taken_res = await this.fetch_leave_taken_consolidated();
	
				if (leave_taken_res?.status === 'OK') 
					this.leave_taken_consolidated_response(leave_taken_res.leave_taken_consolidated);
				
				// Fetch leave adjustments
				let leave_adjustments_res = await this.fetch_leave_adjustments();
	
				if (leave_adjustments_res) 
					this.leave_adjustments_response(leave_adjustments_res.leave_adjustments);
	
				Utils.refresh_data_visible_roles();
			}
		}
		catch (error)
		{
			Grape.alerts.alert({ type: 'error', title: 'Error', message: error.message });
		}
	}
	
	// Helper function to fetch leave earned
	async fetch_leave_earned()
	{
		try 
		{
			
			return await Grape.fetches.postJSON('/leave/get_leave_earned', {
				employee_id: this.employee_id(),
				sortmethod: this.leave_earned_sortingMethod(),
				limit: this.current_page_size(),
				offset: (this.current_page_number() - 1) * this.current_page_size()
			});
		}
		catch (error)
		{
			console.error('Error fetching leave earned:', error);
			throw error;
		}
	}
	
	// Handle leave earned response
	async leave_earned_response(res)
	{
		if (res?.status !== 'ERROR')
		{
			if (res.leave_earned && Array.isArray(res.leave_earned))
			{
				this.leave_earned(res.leave_earned);
				this.page_count(Math.ceil(res.total_records / this.current_page_size()));
				this.pagination_summary(`Showing page ${this.current_page_number()} of ${this.page_count()} (${res.total_records} records)`);
			}
			else
			{
				this.leave_earned([]);
				this.page_count(0);
				this.pagination_summary('No leave earned found.');
			}
		}
		Utils.refresh_data_visible_roles();
	}
	
	// Helper function to fetch leave taken consolidated
	async fetch_leave_taken_consolidated()
	{
		try
		{
			return await Grape.fetches.postJSON('/leave/get_leave_taken_consolidated', {
				employee_id: this.employee_id(),
				sortmethod: this.leavetaken_sortingMethod(),
			});
		}
		catch (error)
		{
			console.error('Error fetching leave taken consolidated:', error);
			throw error;
		}
	}
	
	// Handle leave taken consolidated response
	leave_taken_consolidated_response(leaveTakenConsolidated)
	{
		if (leaveTakenConsolidated == null)
			this.leave_taken_consolidated.removeAll();
		
		else
		{
			let leave_taken_consolidated = leaveTakenConsolidated.map((item) => {
				let leave_taken = ko.observableArray();
				item.leave_taken.forEach((leaveItem) => {
					let leave = new Leave(leaveItem);
					leave.date_start.extend({ update_amount: { parent: leave, type: 'date_start' } });
					leave.date_end.extend({ update_amount: { parent: leave, type: 'date_end' } });
					leave.leave_type_id.extend({ update_amount: { parent: leave, type: 'leave_type_id' } });
					leave.leave_linked_id.extend({ update_amount: { parent: leave, type: 'leave_linked_id' } });
					leave.is_amount_editiable(leaveItem.date_start === leaveItem.date_end);
					leave_taken.push(leave);
				});
				item.leave_taken = leave_taken;
				return item;
			});
			this.leave_taken_consolidated(leave_taken_consolidated);
		}
	}
	
	async fetch_leave_adjustments()
	{
		try
		{
			return await Grape.fetches.postJSON('/leave/get_leave_adjustments', {
				employee_id: this.employee_id(),
				sortmethod: this.leaveadjustment_sortingMethod(),
			});
		}
		catch (error)
		{
			console.error('Error fetching leave adjustments:', error);
			throw error;
		}
	}
	
	leave_adjustments_response(leaveAdjustments)
	{
		if (leaveAdjustments == null)
			this.leave_adjustments.removeAll();
		
		else 
			this.leave_adjustments(leaveAdjustments.map((adjustment) => new LeaveAdjustment(adjustment)));
	}

	// TODO: All of this jQuery needs to be removed...
	cancel_edit(v, e)
	{
		let row = $(e.currentTarget).parent().parent().parent().parent();
		row.find('.edit').hide();
		row.find('.view').show();
		$(e.currentTarget).closest('tbody').find('th button').prop('disabled', false);
	}

	show_leave_breakdown(v, e)
	{
		let row = $(e.currentTarget).parent().parent().parent();
		row.addClass('open');
		row.find('.leave_taken_holder').slideDown('fast', () => {
			// Animation complete.
			$(e.currentTarget).hide()
			row.find('.hideBtn').show()
		});
	}

	hide_leave_breakdown(v, e)
	{
		let row = $(e.currentTarget).parent().parent().parent();
		row.removeClass('open');
		row.find('.leave_taken_holder').slideUp('fast', () => {
			// Animation complete.
			$(e.currentTarget).hide();
			row.find('.showBtn').show();
		});
	}

	expand_all_transaction_groups()
	{
		$('.leave_taken_consolidated').addClass('open');
		$('.leave_taken_holder').slideDown('fast', function() {
			// Animation complete.
			$(this).parent().find('.hideBtn').show();
			$(this).parent().find('.showBtn').hide();
		});
	}

	contract_all_transaction_groups()
	{
		$('.leave_taken_consolidated').removeClass('open');
		$('.leave_taken_holder').slideUp('fast', function() {
			// Animation complete.
			$(this).parent().find('.hideBtn').hide();
			$(this).parent().find('.showBtn').show();
		});
	}

	add_leave_adjustment()
	{
		this.leave_adjustments.unshift(new LeaveAdjustment());
		let row = $('#leave_adjustment_body > tr:nth-child(1)');
		row.find('.edit').show();
		row.find('.view').hide();

		autocomplete(document.getElementById('txtLeaveReason'), global_AutoComplete_Dictionary_Leave_Reason);
	}

	async add_leave_consolidated()
	{
		await Grape.dialog.open('InsertLeaveEntry', { employee_id: this.employee_id(), employment_info: this.employee().employment_info, employeeHolidayDates: this.employeeEventDates() });
		this.updateData();
		window.localStorage.setItem('last-profile-tab', 'leave-tab');
	}

	add_leave(v, e)
	{
		let existing_new_leave = v.leave_taken().find((leave) => leave.leave_taken_id === null);

		if (existing_new_leave)
		{
			Grape.alerts.alert({ type: 'warning', message: tr('You already have an unsaved leave entry. Please save or discard it before adding a new one.'), title: tr('Warning') });
			$(e.currentTarget).prop('disabled', true);
			return;
		}
		let new_leave = new Leave();
		new_leave.transaction_id = v.transaction_id;
		v.leave_taken.unshift(new_leave);

		let row = $('#leave_taken_body_' + v.transaction_id + ' > tr:nth-child(1)');
		row.find('.edit').show();
		row.find('.view').hide();

		autocomplete(document.getElementById('txtLeaveReason'), global_AutoComplete_Dictionary_Leave_Reason);

		$(e.currentTarget).prop('disabled', true);
	}

	async add_leave_modal()
	{
		await Grape.dialog.open('EmployeeLeaveEntry', { employee_id: this.employee_id(), employment_info: this.employee().employment_info });
		this.updateData();
		window.localStorage.setItem('last-profile-tab', 'leave-tab');
	}

	edit_transaction_group(v, e)
	{
		let row = $(e.currentTarget).parent().parent().parent().parent().parent();
		row.find('.edit').show();
		row.find('.view').hide();

		row.find('.input-daterange input').each(() => { });

		// setup the autocomplete
		autocomplete(document.getElementById('txtLeaveReason'), global_AutoComplete_Dictionary_Leave_Reason);

		// row.find(".edit").prop('disabled',true);
		row.find('.SavannaAutoComplete_Leave_Reason').prop('disabled', false);
		row.find('.btn-default').prop('disabled', false);
		
		//hide dropdown after selecting edit reason
		$(e.currentTarget).closest('.ps-dropdown').hide();
	}

	edit_leave_taken_entry(v, e)
	{
		let row = $(e.currentTarget).parent().parent().parent().parent().parent();
		row.find('.edit').show();
		row.find('.view').hide();

		row.find('.input-daterange input').each(() => { });

		// setup the autocomplete
		autocomplete(document.getElementById('txtLeaveReason'), global_AutoComplete_Dictionary_Leave_Reason);

		// row.find(".edit").prop('disabled',true);
		row.find('.SavannaAutoComplete_Leave_Reason').prop('disabled', false);
		row.find('.btn-default').prop('disabled', false);

		//hide dropdown after selecting edit_leave_taken_entry
		$(e.currentTarget).closest('.ps-dropdown').hide();
	}

	edit_leave_adjustment(v, e)
	{
		let row = $(e.currentTarget).parent().parent().parent().parent().parent();
		row.find('.edit').show();
		row.find('.view').hide();

		// setup the autocomplete
		autocomplete(document.getElementById('txtLeaveReason'), global_AutoComplete_Dictionary_Leave_Reason);
	}

	async add_linked_leave()
	{
		await Grape.dialog.open('EmployeeAddLinkedLeave', { employee_id: this.employee_id(), employment_info: this.employee().employment_info });
		this.updateData();
	}

	async add_linked_leave_by_category()
	{
		await Grape.dialog.open('EmployeeAddLinkedLeaveByCategory', { employee_id: this.employee_id(), employment_info: this.employee().employment_info });
		this.updateData();
	}

	async undo_convert_leave(v, e)
	{
		let data = ko.toJS(v);
		let response = await Grape.alerts.confirm({ type: 'warning', title: tr('Warning'), message: tr('Are you sure you want to undo this conversion ?') });

		if (response)
		{
			let res = await Grape.fetches.postJSON('/leave/undo_leave_conversion', data);

			if (res)
			{
				if (res.status == 'OK')
				{
					Grape.alerts.alert({ type: 'success', message: tr('Undo successful.'), title: tr('Success') });
					this.updateData();
				}
				else if (res.status == 'ERROR')
					Grape.alerts.apiError(res);
				else
					Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });
			}
		}
	}

	async remove_linked_leave(v, e)
	{
		let data = ko.toJS(v);
		data.employee_id = this.employee_id();
		let response = await Grape.alerts.confirm({ type: 'warning', title: tr('Warning'), message: tr('Are you sure you want to remove this linked leave ?') });

		if (response)
		{
			let res = await Grape.fetches.postJSON('/leave/remove_linked_leave', data);

			if (res)
			{
				if (res.status == 'OK')
				{
					Grape.alerts.alert({ type: 'success', message: tr('Successfully removed linked leave.'), title: tr('Success') });
					this.updateData()
				}
				else if (res.status == 'ERROR')
					Grape.alerts.apiError(res);
				else
					Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });
			}
		}
	}

	async end_linked_leave(v, e)
	{
		let data = ko.toJS(v);
		await Grape.dialog.open('EmployeeEndLeaveType', { employee_id: this.employee_id(), leave_type_id: data.leave_type_id, leave_linked_id: data.leave_linked_id });
		this.updateData();
	}

	async convert_linked_leave(v, e)
	{
		let data = ko.toJS(v);
		await Grape.dialog.open('EmployeeConvertLeaveType', { employee_id: this.employee_id(), leave_type_id: data.leave_type_id, leave_linked_id: data.leave_linked_id });
		this.updateData();
	}

	edit_leave_earned(v, e)
	{
		let view_row = $(e.currentTarget).parent().parent().parent();
		let edit_row = $(e.currentTarget).parent().parent().parent().next();
		view_row.hide();
		edit_row.show();
	}

	/** employee notes functions end **/
	async save_leave_earned(v, e)
	{
		let data = ko.toJS(v);
		data.employee_id = this.employee_id();

		//validation
		let valid = true;
		let msg = '';

		if (!data.amount)
		{
			valid = false;
			msg = tr('Please enter an amount');
		}

		if (valid)
		{
			let res = await Grape.fetches.postJSON('/leave/update_leave_earned', data);

			if (res)
			{
				if (res.status == 'OK')
				{
					Grape.alerts.alert({ type: 'success', message: tr('Successfully updated earned leave.'), title: tr('Success') });
					this.updateData();
				} 
				else
					Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });
			};
		};

		let view_row = $(e.currentTarget).parent().parent().prev();
		let edit_row = $(e.currentTarget).parent().parent();
		view_row.show();
		edit_row.hide();
	}

	async save_leave_adjustment(v, e)
	{
		let data = ko.toJS(v);
		data.employee_id = this.employee_id();

		// Validation
		let valid = true;
		let msg = '';

		if (!data.leave_linked_id)
		{
			valid = false;
			msg = tr('Please select a leave type');
		}
		else if (!data.entry_date)
		{
			valid = false;
			msg = tr('Please enter a date');
		}
		else if (!data.amount)
		{
			valid = false;
			msg = tr('Please enter an amount');
		};

		if (valid)
		{
			let res = await Grape.fetches.postJSON('/leave/save_leave_adjustment', data);
			if (res)
			{
				if (res.status == 'OK')
				{
					Grape.alerts.alert({ type: 'success', message: tr('Successfully inserted leave adjustment.'), title: tr('Success') });
					this.updateData();
				}
				else if (res.status == 'ERROR')
					Grape.alerts.apiError(res);
				else
					Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });
			}
		}

		let view_row = $(e.currentTarget).parent().parent().prev();
		let edit_row = $(e.currentTarget).parent().parent();
		view_row.show();
		edit_row.hide();
	}

	async delete_leave_earned(v, e)
	{
		let response = await Grape.alerts.confirm({ type: 'warning', title: tr('Warning'), message: tr('Are you sure you want to remove this leave earned?') });
		if (response)
		{
			let data = ko.toJS(v)
			let res = await Grape.fetches.postJSON('/leave/remove_leave_earned', data);

			if (res)
			{
				if (res.status == 'OK')
				{
					Grape.alerts.alert({ type: 'success', message: tr('Successfully removed earned leave.'), title: tr('Success') });
					this.updateData();
				}
				else if (res.status == 'ERROR')
					Grape.alerts.apiError(res);
				else
					Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });
			}
		}
	}

	async generate_leave()
	{
		let data = {
			employee_id: this.employee_id()
		}

		let res = await Grape.fetches.postJSON('/leave/generate_leave_earned', data);
		if (res)
		{
			if (res.status == 'OK')
			{
				Grape.alerts.alert({ type: 'success', message: tr('Successfully generated leave.'), title: tr('Success') });
				this.updateData();
			}
			else if (res.status == 'ERROR')
				Grape.alerts.apiError(res);
			else
				Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });
		}
	}

	async delete_leave_taken(v, e)
	{
		let response = await Grape.alerts.confirm({ type: 'warning', title: tr('Warning'), message: tr('Are you sure you want to proceed?') });
		if (response)
		{
			let data = ko.toJS(v)

			let res = await Grape.fetches.postJSON('/leave/delete_leave_taken_entry_and_lock', data);
			if (res)
			{
				if (res.status == 'OK')
				{
					Grape.alerts.alert({ type: 'success', message: tr('Successfully removed leave.'), title: tr('Success') });
					this.updateData();
				}
				else if (res.status == 'ERROR')
					Grape.alerts.apiError(res);
				else
					Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });
			}
		}
	}

	async delete_leave_transaction(v, e)
	{
		let response = await Grape.alerts.confirm({ type: 'warning', title: tr('Warning'), message: tr('Please note: Deleting this leave deletes all leave under this transaction (leave request) which could be multiple leave taken entries. Are you sure you want to proceed?') });
		if (response)
		{
			let data = ko.toJS(v);
			let specific_data_required = {
				transaction_id: data.transaction_id,
			}

			let res = await Grape.fetches.postJSON('/leave/delete_leave_by_transaction_id', specific_data_required);
			if (res)
			{
				if (res.status == 'OK')
				{
					Grape.alerts.alert({ type: 'success', message: tr('Successfully removed leave.'), title: tr('Success') });
					this.updateData();
				}
				else if (res.status == 'ERROR')
					Grape.alerts.apiError(res);
				else
					Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });
			}
		}
	}

	async reprocess_leave(v, e)
	{
		let response = await Grape.alerts.confirm({ type: 'danger', title: tr('Reprocess leave'), message: tr('Are you sure you want to reprocess the leave? Reprocessing this leave will reset the entire leave taken entry to the original entry.') });
		if (response)
		{
			let data = ko.toJS(v);
			let res = await Grape.fetches.postJSON('/leave/reprocess', { transaction_id: data.transaction_id });

			if (res)
			{
				if (res.status == 'OK')
				{
					Grape.alerts.alert({ type: 'success', message: tr('Successfully re-processed leave.'), title: tr('Success') });
					this.updateData();
				}
				else if (res.status == 'ERROR')
					Grape.alerts.apiError(res);
				else
					Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });
			}
		}
	}

	async delete_leave_adjustment(v, e)
	{
		let response = await Grape.alerts.confirm({ type: 'warning', title: tr('Warning'), message: tr('Are you sure you want to remove this leave adjustment?') });
		if (response)
		{
			let data = ko.toJS(v);
			let res = await Grape.fetches.postJSON('/leave/remove_leave_adjustment', data);

			if (res)
			{
				if (res.status == 'OK')
				{
					Grape.alerts.alert({ type: 'success', message: tr('Successfully removed leave adjustment.'), title: tr('Success') });
					this.updateData();
				}
				else if (res.status == 'ERROR')
					Grape.alerts.apiError(res);
				else
					Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });
			}
		}
	}

	async cancel_leave(v, e)
	{
		let response = await Grape.alerts.confirm({ type: 'warning', title: tr('Warning'), message: tr('Are you sure you want to cancel this leave request?') });
		if (response)
		{
			let data = ko.toJS(v);
			let res = await Grape.fetches.postJSON('/leave/cancel_leave', data);

			if (res)
			{
				if (res.status == 'OK')
				{
					Grape.alerts.alert({ type: 'success', message: tr('Successfully cancelled leave.'), title: tr('Success') });
					this.updateData();
				}
				else if (res.status == 'ERROR')
					Grape.alerts.apiError(res);
				else
					Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });
			}
		}
	}

	async request_cancellation(v, e)
	{
		let response = await Grape.alerts.confirm({ type: 'warning', title: tr('Warning'), message: tr('Are you sure you want to request for this leave to be removed?') });
		if (response)
		{
			let data = ko.toJS(v);
			let res = await Grape.fetches.postJSON('/leave/cancellation_request', data);

			if (res)
			{
				if (res.status == 'OK')
				{
					Grape.alerts.alert({ type: 'success', message: tr('Successfully requested for leave to be cancelled.'), title: tr('Success') });
					this.updateData()
				}
				else if (res.status == 'ERROR')
					Grape.alerts.apiError(res);
				else
					Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });
			}
		}
	}

	async upload_leave_document(v, e)
	{
		let data = ko.toJS(v);
		await Grape.dialog.open('EmployeeUploadLeaveDocument', { employee_id: this.employee_id(), transaction_id: data.transaction_id });
		this.updateData();
	}

	async save_leave_transaction_group(v, e)
	{
		let data = ko.toJS(v);
		let row = $(e.currentTarget).parent().parent();

		// do some additional checks
		let res = await Grape.fetches.postJSON('/leave/edit_leave_transaction', data);
		if (res)
		{
			if (res.status == 'OK')
			{
				Grape.alerts.alert({ type: 'success', message: tr('Successfully saved.'), title: tr('Success') });
				this.updateData();
			}
			else if (res.status == 'ERROR')
			{
				Grape.alerts.apiError(res);
				this.updateData();
			}
			else
			{
				Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });
				this.updateData();
			}

			row.find('.edit').hide();
			row.find('.view').show();
		}
	}

	cancel_transaction_group(v, e) {
		let row = $(e.currentTarget).closest('.leave_taken_consolidated_buttons');
		row.find('.edit').hide();
		row.find('.view').show();
		row.find('.ps-dropdown').show();
		row.find('.showBtn').show(); 
	}

	async save_leave_taken_entry(v, e)
	{
		let data = ko.toJS(v);
		let row = $(e.currentTarget).parent().parent();

		data.employee_id = this.employee_id();
		if (data.leave_taken_id == null) data.leave_taken_id = -1;

		let URL = '/leave/save_transaction_entry_and_lock';

		if (data.leave_taken_id != -1)
			URL = '/leave/edit_leave_taken_entry_and_lock';

		// validation
		let valid = true;
		let msg = '';
		if (data.date_start == '')
		{
			valid = false;
			msg = tr('Please make sure the date is correct before saving');
		}
		else if (isNaN(Number(data.amount)))
		{
			valid = false;
			msg = tr('Please make sure your amount of days is a number');
		}
		else if (Number(data.amount) > 1)
		{
			let response = await Grape.alerts.confirm({ type: 'warning', title: tr('Warning'), message: tr('Please note that you are trying to save a value greater than 1 for a single day. This is not recommended. Do you wish to save anyway?') });
			if (!response)
			{
				valid = false;
				msg = tr('Leave not saved - cancelled by user.');
			}
		}
		else if (data.is_overlapping == true)
		{
			let response = await Grape.alerts.confirm({ type: 'warning', title: tr('Warning'), message: tr('Please note that you are trying to save leave that is overlapping current leave processed. Do you wish to save anyway?') });
			if (!response)
			{
				valid = false
				msg = tr('Leave not saved - cancelled by user.')
			}
		}

		// do some additional checks
		if (valid)
		{
			let res = await Grape.fetches.postJSON(URL, data);

			if (res)
			{
				if (res.status == 'OK')
				{
					Grape.alerts.alert({ type: 'success', message: tr('Successfully saved.'), title: tr('Success') });
					this.updateData();
				}
				else if (res.status == 'ERROR')
				{
					Grape.alerts.apiError(res);
					this.updateData();
				}
				else
				{
					Grape.alerts.alert({ type: 'error', message: tr('Something went wrong...'), title: tr('Error') });
					this.updateData();
				}

				row.find('.edit').hide();
				row.find('.view').show();

				$(e.currentTarget).closest('tbody').find('th button').prop('disabled', false);
			}
		}
		else
			Grape.alerts.alert({ type: 'error', message: msg, title: tr('Error') });
	};
}

export default {
	name: 'employee_view_leave_component',
	viewModel: EmployeeViewLeaveComponentViewModel,
	module_type: 'ko',
	template: template,
	template_filename: 'translation/components/employee_view_leave_component'
};
